/* Quelton — capa editorial: los vídeos (taller, Bandida…) solo se descargan y se reproducen cuando se ven en pantalla. */
(function () {
  'use strict';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const start = (v) => { if (!v.src && v.dataset.src) v.src = v.dataset.src; if (!reduce) v.play().catch(() => {}); };
  function init(root) {
    const vids = Array.from((root || document).querySelectorAll('video[data-jq-video]'));
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) { vids.forEach(start); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) start(en.target); else en.target.pause();
    }), { threshold: 0.25 });
    vids.forEach((v) => io.observe(v));
  }
  document.addEventListener('DOMContentLoaded', () => init());
  // editor de temas: al recargar una sección
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
